import { render, staticRenderFns } from "./ItemColumn.vue?vue&type=template&id=552e7426"
import script from "./ItemColumn.vue?vue&type=script&lang=js"
export * from "./ItemColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports